export function updateIntegralXShift(datum, shiftValue) {
    datum.integrals.values = datum.integrals.values.map((integral) => ({
        ...integral,
        from: integral.originFrom + shiftValue,
        to: integral.originTo + shiftValue,
    }));
}
